<script setup>

</script>

<template>
  <div class="footer" id="footer">
    <span class="logo">대구광역시</span>
    <span class="address">동인청사 : (우 41911) 대구광역시 중구 공평로 88 / 산격청사 : (우 41542) 대구광역시 북구 연암로 40 / 전화번호 : 053)120</span>
    <span class="copyright">Copyright© Daegu Metropolitan City. All right reserved.</span>
  </div>
</template>

<style scoped>

</style>